var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',{staticClass:"page"},[_c('v-container',{staticClass:"temp-container",attrs:{"fluid":""}},[_c('router-view')],1)],1),(_vm._showFilter)?_c('LateralMenu'):_vm._e(),_c('div',{staticClass:"sync-language-menu-anchor"},[_c('LanguageMenu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }